import * as React from 'react';
import { useSelector } from 'react-redux';

import { chatListSelector } from '../selectors';

interface ILeftSwipeVisibleProviderProps {
  children: React.ReactNode;
}
export type LeftSwipeVisibleContextProps = {
  isLeftSwipeVisible: boolean;
  setIsLeftSwipeVisible: React.Dispatch<React.SetStateAction<boolean>>;
};

const LeftSwipeVisibleContext = React.createContext<LeftSwipeVisibleContextProps | undefined>(undefined);

export const LeftSwipeVisibleProvider: React.FC<ILeftSwipeVisibleProviderProps> = ({ children }) => {
  const { currentRoute, isLoadProgress } = useSelector(chatListSelector);
  const [isLeftSwipeVisible, setIsLeftSwipeVisible] = React.useState(false);
  const [currentRouteState, setCurrentRouteState] = React.useState(currentRoute);

  // Кнопка слева не должна быть видна, пока не смахнули вправо. К сожалению, только JS...
  // При смене роута обнуляем кнопку слева
  React.useEffect(() => {
    setTimeout(() => {
      setIsLeftSwipeVisible(false);
    }, 0);
    setCurrentRouteState(currentRoute);
  }, [currentRoute]);

  // При загрузке (в момент рендера списка) списка обнуляем кнопку слева
  React.useEffect(() => {
    if (currentRoute === currentRouteState && isLoadProgress) {
      setTimeout(() => {
        setIsLeftSwipeVisible(false);
      }, 0);

      return;
    }

    if (isLoadProgress) {
      setTimeout(() => {
        setIsLeftSwipeVisible(false);
      }, 0);
    } else {
      setTimeout(() => {
        setIsLeftSwipeVisible(false);
        setIsLeftSwipeVisible(true);
      }, 0);
    }
  }, [isLoadProgress, currentRoute]);

  const contextValue = React.useMemo(() => ({ isLeftSwipeVisible, setIsLeftSwipeVisible }), [isLeftSwipeVisible]);

  return <LeftSwipeVisibleContext.Provider value={contextValue}>{children}</LeftSwipeVisibleContext.Provider>;
};

export const useLeftSwipeVisible = (): LeftSwipeVisibleContextProps => {
  const context = React.useContext(LeftSwipeVisibleContext);
  if (context === undefined) {
    throw new Error('useLeftSwipeVisible must be used within a LeftSwipeVisibleProvider');
  }

  return context;
};
